<template>
  <div
    v-show="!disabled"
    class="cm-state-card"
  >
    <h4
      v-if="title"
      class="cm-title"
    >
      {{ title }}
    </h4>

    <div
      class="cm-state-card__body"
      :class="{'cm-state-card__body--not-ok': isLoading || isError || isEmpty }"
      :style="{width, minHeight: height}"
    >
      <spinner-dots
        v-if="isLoading"
        :size="width / 5"
      />
      <p
        v-else-if="isError"
        class="cm-state-card__body--error"
      >
        Ошибка при получении данных
      </p>
      <p
        v-else-if="isEmpty"
        class="cm-state-card__body--empty"
      >
        Нет данных
      </p>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import SpinnerDots from "@/manzana_library/components/Elements/SpinnerDots.vue";

export default {
  name: "CmStateCard",
  components: {
    SpinnerDots,
  },
  props: {
    title: {
      type: String,
    },
    width: {
      type: String,
      // default: 'fit-content'
    },
    height: {
      type: String,
      // default: "auto"
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.cm-state-card {
  &__body {
    border-radius: 5px;
    width: 670px;
    min-height: 300px;

    &--error {
      font-size: 20px;
      color: $color_error;
    }

    &--empty {
      font-size: 18px;
      color: $color_black_8;
    }

    &--not-ok {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
